import { getAuth, sendEmailVerification } from "firebase/auth";
import { useEffect, useState } from "react";

export default function VerificationPageViewModel() {
  const [AuthUser, setAuthUser] = useState();

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        setAuthUser(user);
      });
    }
    fetchData();
  }, []);

  const ResendEmail = async () => {
    await sendEmailVerification(AuthUser)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  };
  return [AuthUser, ResendEmail];
}
